import { createStore } from 'vuex'
import router from '../router'; // Asegúrate de la ruta correcta

export default createStore({
  state: {
    params: {},
    datosemp: {},
    optionSelected: '',
    datoscolor: {},
    registros: [],
    instrucciones: 'Introduce tu DNI',
    mode: 'dni',
    teletrabajo: false,
    dniGuardado: false,
    settings: {},
    photoData: false
  },
  getters: {
  },
  mutations: {
    setParams(state, data) {
      state.params = data;
    },
    setDatosEmp(state, data) {
      state.datosemp = data;
    },
    setRegistros(state, data) {
      state.registros = data;
    },
    setSettings(state, data) {
      state.settings = data;
    },
    setPhotoData(state, data) {
      state.photoData = data;
    },
    validarRegistro(state, accion) {
      state.mode = 'pin';
      state.instrucciones = 'Introduce el PIN para continuar';
      state.optionSelected = accion;
      router.push('/validate');
    },
    setMode(state, data) {
      state.mode = data;
    },
    setInstrucciones(state, data) {
      state.instrucciones = data;
    },
    setTeletrabajo(state, data) {
      state.teletrabajo = data;
    },
    setDniGuardado(state, data) {
      state.dniGuardado = data;
    }
  },
  actions: {

  },
  modules: {
  }
})
